import { OutDebt } from '../generated/graphql';

const daysBehindMultipliers: { min: number, max?: number, percent: number }[] = [
  { min: 11, max: 30, percent: 0.013 },
  { min: 31, max: 60, percent: 0.058 },
  { min: 61, max: 180, percent: 0.12 },
  { min: 181, percent: 0.2 },
];

export const getCommissionMultiplier = (
  { daysBehind }: OutDebt,
) => {
  const compare = daysBehind || 0;
  return daysBehindMultipliers
    .find(({ min, max }) => compare >= min && compare <= (max || 0))?.percent
    || 0;
};
